export default __webpack_public_path__ + "static/media/landscape10.5c38cb26.jpg";